import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { ProfessionGenericRecommendationCard } from 'portfolio3/features/pdf/components/cards';
import { IndustrySpecialityList } from 'portfolio3/features/proforientation';
import { RecommendationDodMappedData } from 'portfolio3/features/proforientation/model/selectors/recommendations';
import { activeFormatSelector } from 'selectors/drawers';

import SpecialityContainer from './SpecialityContainer';

type RecommendationOpenDaySectionProps = {
  data: RecommendationDodMappedData[];
};
const RecommendationOpenDaySection = ({ data }: RecommendationOpenDaySectionProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="recommendation-open-day">
      <Typography variant="Headings/H5">Дни открытых дверей</Typography>
      <Box marginTop="16px" className="recommendation-open-day__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((event) => {
            return (
              <ProfessionGenericRecommendationCard
                key={event.eventId}
                date={event.formattedDate}
                industry={event.industry}
                name={event.name}
                place={event.place}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default RecommendationOpenDaySection;
